<template>
  <v-layout>
    <v-flex>
      <div>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="getGifs">
          <v-toolbar color="#d13b55" dark>
            <v-toolbar-title>Search</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchTerm"
              label="search GIPHY"
              @keyup.enter="getGifs"
              :rules="requiredRules"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="getGifs()" :disabled="!valid">
              <v-icon>search</v-icon>
            </v-btn>
          </v-toolbar>
        </v-form>
      </div>
      <div class="text-xs-center" style="background-color: #ffffff">
        <v-btn-toggle v-model="toggle_gif" mandatory @change="gifToggle">
          <v-btn flat title="Trending">
            <v-icon>trending_up</v-icon>
          </v-btn>
          <v-btn flat title="Ovation">
            <v-icon>sign_language</v-icon>
          </v-btn>
          <v-btn flat title="Emoticons">
            <v-icon>emoji_emotions</v-icon>
          </v-btn>
          <v-btn flat title="Yes">
            <v-icon>thumb_up_alt</v-icon>
          </v-btn>
          <v-btn flat title="Party">
            <v-icon>celebration</v-icon>
          </v-btn>
          <v-btn flat title="Stickers">
            <v-icon>format_quote</v-icon>
          </v-btn>
        </v-btn-toggle>
      </div>
      <div
        style="
          max-height: 400px;
          background-color: #ffffff;
          overflow-x: hidden;
          overflow-y: auto;
        "
      >
        <v-container grid-list-sm fluid>
          <v-layout row wrap>
            <v-flex v-for="gif in gifs" :key="gif.id" xs4 d-flex>
              <v-card flat tile class="d-flex">
                <v-img
                  :src="gif"
                  lazy-src="https://picsum.photos/10/6?image=1"
                  aspect-ratio="1"
                  class="grey lighten-2 pointer-cursor"
                  @click.prevent="$emit('onGifPicked', gif)"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import validationRules from "@/js/validationRules.js";
import { GiphyFetch } from "@giphy/js-fetch-api";
const gf = new GiphyFetch("j0RtHZHnVQdS2BGT787oIwSAettvo6If");

export default {
  emits: ["onGifPicked"],
  data() {
    return {
      valid: true,
      searchTerm: "ovation",
      gifs: [],
      toggle_gif: 1,
      requiredRules: validationRules.requiredRules,
    };
  },
  methods: {
    async getGifs() {
      const { data: gifs } = await gf.search(this.searchTerm, { limit: 48 });
      this.buildGifs(gifs);
    },
    buildGifs(json) {
      this.gifs = json
        .map((gif) => gif.id)
        .map((gifId) => {
          return `https://media.giphy.com/media/${gifId}/giphy-preview.gif`;
        });
    },
    async gifToggle(toggleIndex) {
      if (toggleIndex == 0) {
        this.searchTerm = "trending";
        const { data: gifs } = await gf.trending({ limit: 48 });
        this.buildGifs(gifs);
      } else if (toggleIndex == 1) {
        this.searchTerm = "ovation";
        await this.getGifs();
      } else if (toggleIndex == 2) {
        this.searchTerm = "emoticons";
        const { data: gifs } = await gf.emoji({ limit: 99 });
        this.buildGifs(gifs);
      } else if (toggleIndex == 3) {
        this.searchTerm = "yes";
        await this.getGifs();
      } else if (toggleIndex == 4) {
        this.searchTerm = "party";
        await this.getGifs();
      } else if (toggleIndex == 5) {
        this.searchTerm = "congratulations";
        const { data: gifs } = await gf.search(this.searchTerm, {
          limit: 48,
          type: "stickers",
        });
        this.buildGifs(gifs);
      }
    },
  },
  async beforeMount() {
    await this.getGifs();
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0px;
}
</style>